import {
  registerCustomDetailComponent,
  registerFormInputComponent,
} from "@bb-vendure/admin-ui/core";
import ExchangeRateComponent from "./exchange-rate/rate.component";
import CurrencySelector from "./country-currency-selector/selector.component";
export default [
  registerFormInputComponent("currency-code-selector", CurrencySelector),
];
